module.exports = __webpack_public_path__ + "static/media/oil.f8cc3008.svg";